import { render } from "./whatsappButton.vue?vue&type=template&id=b5986000&scoped=true"
import script from "./whatsappButton.vue?vue&type=script&lang=js"
export * from "./whatsappButton.vue?vue&type=script&lang=js"

import "./whatsappButton.vue?vue&type=style&index=0&id=b5986000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5986000"]])

export default __exports__